export default __webpack_public_path__ + "e6c8e01a9455b6b5b367c3c50f08d374.svg";